import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkEmailAvailable } from '../../actions/EmailActions';

export default function useEmailAvailability() {
    const [ emailAvailability, setEmailAvailability ] = useState({
        emailCheckPerformed: false,
        available: false
    });
    const [ status, setStatus ] = useState({
        hasError: false,
        errorMessage: ''
    });

    const { emailCheckSuccessful, emailAvailableResponse } = useSelector(state => ({
        emailCheckSuccessful: state.emailAvailable.emailCheckSuccessful,
        emailAvailableResponse: state.emailAvailable.emailAvailableResponse
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        if (emailCheckSuccessful) {
            setEmailAvailability({
                emailCheckPerformed: true,
                available: emailAvailableResponse.data
            });
        } else if (emailAvailableResponse) {
            setStatus({
                hasError: true,
                errorMessage: 'Error checking email availability. Please try again.'
            });
        }
    }, [emailCheckSuccessful, emailAvailableResponse]);

    function checkEmailInUse(email) {
        dispatch(checkEmailAvailable(email));
    }

    return { emailAvailability, setEmailAvailability, status, setStatus,
        emailCheckSuccessful, emailAvailableResponse, checkEmailInUse };
}
